import * as React from "react";
import NextImage from "next/image";
import { Stack, Text, BoxProps, Heading, Box } from "@chakra-ui/react";

type TAlignment = "left" | "center";

const IconList: React.FC<{
  image: string;
  body: React.ReactNode | string | null;
  contentHeight?: string;
  title?: string | React.ReactNode | null;
  align?: TAlignment;
  customWidth?: BoxProps["width"];
  priority?: boolean;
}> = ({
  priority,
  image,
  body,
  title,
  align = "center",
  customWidth = "265px",
}) => (
  <Stack
    boxSizing="border-box"
    w={customWidth}
    alignItems={{
      base: "center",
      xl: align === "left" ? "flex-start" : align,
    }}
    mb="20px"
    padding={{ base: "15px", xl: 0 }}
  >
    <NextImage priority={priority} src={image} alt="" width="80" height="80" />

    {title && (
      <Box pt="14px">
        {typeof title === "string" ? (
          <Heading as="h3" textAlign={{ base: "center", xl: align }}>
            {title}
          </Heading>
        ) : (
          title
        )}
      </Box>
    )}
    <Box>
      {typeof body === "string" ? (
        <Text textAlign={{ base: "center", xl: align }}>{body}</Text>
      ) : (
        body
      )}
    </Box>
  </Stack>
);

export default IconList;
